// extracted by mini-css-extract-plugin
export default {"container":"News_container__blqDp","header-Q_KPo8tL":"News_header-Q_KPo8tL__lgebk","copyRight":"News_copyRight__6gLAN","blueTextContainer":"News_blueTextContainer__wFOqX"};